// VPS Provider labels for display
export const VPS_PROVIDER_LABELS = {
    aws: 'Amazon Web Services',
    digitalocean: 'DigitalOcean',
    hetzner: 'Hetzner',
    linode: 'Linode',
    vultr: 'Vultr',
    ovh: 'OVH',
    contabo: 'Contabo',
    custom: 'Custom/Other',
};
// VPS Status colors and labels
export const VPS_STATUS_CONFIG = {
    online: { label: 'Online', color: 'green' },
    offline: { label: 'Offline', color: 'red' },
    degraded: { label: 'Degraded', color: 'yellow' },
    unknown: { label: 'Unknown', color: 'gray' },
    maintenance: { label: 'Maintenance', color: 'blue' },
};
// Risk level configuration
export const RISK_LEVEL_CONFIG = {
    low: { label: 'Low', color: 'green' },
    medium: { label: 'Medium', color: 'yellow' },
    high: { label: 'High', color: 'orange' },
    critical: { label: 'Critical', color: 'red' },
};
// Metrics collection interval (in seconds)
export const METRICS_COLLECTION_INTERVAL = 60;
// Data retention (in days)
export const METRICS_RETENTION_DAYS = 90;
// Session expiration (in hours)
export const SESSION_EXPIRATION_HOURS = 24 * 7; // 7 days
// Agent token length
export const AGENT_TOKEN_LENGTH = 64;
// Pagination defaults
export const PAGINATION = {
    DEFAULT_PAGE: 1,
    DEFAULT_LIMIT: 20,
    MAX_LIMIT: 100,
};
// Time ranges for metrics queries
export const TIME_RANGES = {
    '1h': 60 * 60 * 1000,
    '6h': 6 * 60 * 60 * 1000,
    '24h': 24 * 60 * 60 * 1000,
    '7d': 7 * 24 * 60 * 60 * 1000,
    '30d': 30 * 24 * 60 * 60 * 1000,
};
// Resolution options for metrics queries (in seconds)
export const METRICS_RESOLUTIONS = {
    '1m': 60,
    '5m': 300,
    '15m': 900,
    '1h': 3600,
    '1d': 86400,
};
//# sourceMappingURL=constants.js.map